import React from 'react';
import classNames from 'classnames';

import styles from './BaseLabel.module.less';

type LabelProps = {
  status: string;
  statusClassName?: string;
  className?: string;
  iconClasses?: string;
};

const getLabelClassName = (status: string) => {
  const labelStatus = status.toLowerCase();

  switch (labelStatus) {
    case 'assignment pending':
      return styles.assignmentPending;
    case 'active':
      return styles.active;
    case 'inactive':
    case 'pending partnership':
      return styles.inactive;
    case 'completed':
      return styles.completed;
    case 'cancelled':
      return styles.cancelled;
    case 'deactivated':
      return styles.deactivated;
    case 'draft':
      return styles.draft;
    case 'pending':
      return styles.pending;
    case 'declined':
      return styles.declined;
    case 'accepted':
      return styles.accepted;
    case 'withdrawn':
      return styles.withdrawn;
    case 'reviewed':
      return styles.pending;
    case 'initial outreach conducted':
      return styles.pending;
    case 'agreement sent':
      return styles.pending;
    case 'agreement signed':
      return styles.pending;
    case 'profile completed':
      return styles.pending;
    case 'all':
      return styles.all;
    case 'new':
      return styles.new;
    case 'registered, profile not completed':
    case 'ukg: termination failed':
      return styles.declined;
    case 'not registered':
      return styles.withdrawn;
    case 'set up for payments':
      return styles.active;
    case 'registered':
      return styles.registered;
    case 'ukg: awaiting status':
    case 'ukg: termination awaiting':
      return styles.withdrawn;
    case 'ukg: synced':
    case 'ukg: terminated':
      return styles.accepted;
    case 'ukg: synced with errors':
      return styles.withdrawn;
    case 'ukg: sync failed':
      return styles.declined;
    case 'ukg: reprocessed manually':
      return styles.accepted;
    case 'rehired change customer':
      return styles.rehiredWith;
    case 'renewed':
      return styles.renewed;
    case 'rehired':
      return styles.rehired;
    case 'template':
      return styles.accepted;
  }
};

export default function BaseLabel(props: LabelProps) {
  const {
    status,
    className = '',
    statusClassName = status,
    iconClasses,
  } = props;

  return (
    <span
      className={classNames(
        styles.root,
        className,
        getLabelClassName(statusClassName),
      )}
    >
      {iconClasses ? <i className={iconClasses} /> : <></>}
      {status}
    </span>
  );
}
